import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
// TODO: Uncomment when service is available
// import { getPerformanceDevelopmentConsultationsTable } from '@/store/slices/components/dashboard/service';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import SearchInput from '../../SearchInput';
import { developmentConsultationsTypesOptions } from '../utils';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import DevelopmentConsultationsTable from '@/components/Dashboard/DashboardTables/DevelopmentConsultationsTable';
import { getPerformanceDevelopmentConsultationsTable } from '@/store/slices/components/dashboard/service';

export default function DevelopmentConsultationsModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { developmentConsultations } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const {
    count,
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
  } = developmentConsultations;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.DEVELOPMENT_CONSULTATIONS);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(developmentConsultations);

      dispatch(
        getPerformanceDevelopmentConsultationsTable({ query, tableQuery })
      );
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(developmentConsultations);
    downloadExcel(query, tableQuery);
    track.developmentConsultations(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'developmentConsultations';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  return (
    <BaseModal
      id="development-consultations-modal"
      title={`${count} ${Trans(
        translations,
        'DashboardTableTitle.DevelopmentInquiries'
      )}`}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'developmentConsultations',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput
          modal="developmentConsultations"
          dropdownOptions={developmentConsultationsTypesOptions}
        />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <DevelopmentConsultationsTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
